<template>
  <div class="attachment-card">
    <v-layout row>
      <v-flex pl-3 pr-3 pt-3 pb-3>
        <attachment-list :adjuntos="adjunto.assets" :canEdit="canEditFile && puedeBorrarAdjuntos" @removedFile="remove"
        ref="attachmentList">
          <span :class="adjunto.estado === 'A subsanar' ? 'documento-error' : ''">{{ adjunto.tipoAdjunto }}:
          <adjunto-estado :adjunto="adjunto" @changeCurrentStatus="changeAdjuntoStatus"></adjunto-estado>
          </span>
        </attachment-list>
        <div v-if="adjunto.canEdit">
          <div v-if="$store.getters.isSafRole">
            <v-switch @change="cambiarModificarAdjuntos()" v-model="adjunto.canDeleteAttachments" :disbled="saving"
              label="Club puede borrar adjuntos" color="primary lighten-2" :disabled="!adjunto.canEdit"></v-switch>
          </div>
          <div v-if="$store.getters.isClubRole">
            <div class="custom-font-semi-bold custom-text text-grey" v-if="newFileAdded">{{ adjunto.tipoAdjunto }}</div>
            <AttachFile ref="fileInput" :description="true" @upload="uploadFiles"></AttachFile>
            <v-btn @click="openFileDirectory" color="#1787c9" dark class="attach-button" v-if="adjunto.canEdit">
              <v-icon>attach_file</v-icon>
              <span>Agregar {{ adjunto.tipoAdjunto }}</span>
            </v-btn>
          </div>
        </div>
        <div class="observaciones">
          <observaciones :listPath="listPath" :createPath="observacionCreatePath" :editPath="observacionEditPath" @observacionCreada="observacionCreada"
            :canEdit="adjunto.canEdit" payloadId="objectId" :id="adjunto.id" :canAdd="adjunto.canAddObservacion" hideSubmit ref="observaciones"/>
        </div>
        <v-btn right v-if="adjunto.canEdit" color="primary" @click="saveAll" :disabled="saving || (!canSaveFile && !canSaveObservacion)">Guardar</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import AttachmentList from './AttachmentList'
import Observaciones from './Observaciones'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import AdjuntoEstado from './AdjuntoEstado'

export default {
  props: {
    adjunto: Object
  },

  components: {
    AttachFile,
    AttachmentList,
    Observaciones,
    AdjuntoEstado
  },

  mixins: [validationMixin, s3UploadMixin, createEntityMixin],

  validations () {
    return {
      files: {
        required: requiredIf(() => {
          return this.doesNotHavePreviousAttachments && !this.hasAddedFiles() && !this.isLoading() && !this.adjuntos.optional
        })
      }
    }
  },

  data () {
    return {
      adjuntos: [],
      removedFiles: [],
      itemId: [],
      listPath: `informe/adjunto/${this.adjunto.contentTypeId}/${this.adjunto.id}/observaciones`,
      observacionCreatePath: `informe/adjunto/observacion/${this.adjunto.contentTypeId}/${this.adjunto.id}/new`,
      editPath: `informe/editar/${this.$route.params.id}`,
      observacionEditPath: 'informe/adjunto/observacion',
      loading: false,
      isEditing: true
    }
  },

  computed: {
    canEditFile () {
      return this.adjunto.estado !== 'Aprobada' && this.adjunto.canEdit
    },
    puedeBorrarAdjuntos () {
      return this.adjunto.canDeleteAttachments && this.$store.getters.isClubRole
    },
    fileErrors () {
      const errors = []
      if (!this.$v.files.$dirty) return errors
      !this.$v.files.required && errors.push('Adjunto requerido.')
      return errors
    },
    newFileAdded () {
      return this.hasAddedFile()
    },
    canSaveFile () {
      return this.$store.getters.isClubRole && (this.hasAddedFile() || this.hasRemovedFiles())
    },
    canSaveObservacion () {
      return this.adjunto.canAddObservacion
    }
  },

  methods: {
    observacionesSinGuardar () {
      return this.$refs.observaciones.tieneObservacionesSinGuardar
    },
    tieneCambiosSinGuardar () {
      return this.canSaveFile || this.observacionesSinGuardar()
    },
    saveAll () {
      if (this.canSaveFile) {
        this.uploadAllFiles()
      }
      if (this.canSaveObservacion) {
        this.$refs.observaciones.agregarObservacion()
      }
    },
    observacionCreada () {
      this.adjunto.canAddObservacion = false
    },
    changeAdjuntoStatus (estado) {
      const path = `informe/adjunto/corregir/${this.adjunto.contentTypeId}/${this.$route.params.id}/${estado}`
      this.saving = true
      this.axios
        .put(path)
        .then(() => {
          this.saving = false
          this.updatedAdjuntos()
        }
        )
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          this.saving = false
        })
    },
    cambiarModificarAdjuntos () {
      const puedeBorrar = this.adjunto.canDeleteAttachments ? 1 : 0
      const path = `informe/adjunto/${this.adjunto.contentTypeId}/${this.$route.params.id}/club-puede-borrar-adjuntos/${puedeBorrar}`
      this.saving = true
      this.axios
        .put(path)
        .then(() => {
          this.saving = false
        })
        .catch(error => {
          this.saving = false
          this.adjunto.canDeleteAttachments = puedeBorrar ? 0 : 1
          this.$store.commit('setErrorMsg', error)
        })
    },
    getPayload () {
      const payload = {
        'adjuntoTypeId': this.adjunto.contentTypeId
      }
      if (this.hasAddedFile()) {
        payload.addedAdjuntos = this.assets
      }
      if (this.hasRemovedFiles()) {
        payload.deletedAdjuntos = this.removedFiles
      }
      return payload
    },
    updatedAdjuntos () {
      this.$emit('updatedAdjuntos')
    },
    resetComponents () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs.attachmentList.resetComponents()
    },
    postSuccessfulSubmit () {
      this.cleanAddedFiles()
      this.updatedAdjuntos()
      this.postSubmit()
      this.saving = false
    },
    openFileDirectory () {
      this.getFileInput().onPickFile()
    },
    remove (itemId) {
      this.removedFiles.push(itemId)
    },
    isValid () {
      this.$v.$touch()
      return !this.$v.$invalid
    },
    isLoading () {
      return this.loading
    },
    hasAddedFile () {
      return this.files.length > 0
    },
    hasAddedFiles () {
      return this.hasAddedFile()
    },
    hasRemovedFiles () {
      return this.removedFiles.length > 0
    },
    getAddedFile () {
      return this.anexoDeudas
    },
    getRemovedFiles () {
      return this.removedFiles
    },
    getModifiedFiles () {
      return []
    },
    cleanAddedFiles () {
      this.getFileInput().cleanContent()
      this.getFileInput().cleanProgress()
      this.files = []
    },
    cleanRemovedFiles () {
      this.removedFiles = []
    },
    startLoading () {
      this.loading = true
    },
    finishLoading () {
      this.loading = false
    },
    marcarObservacionesLeidas () {
      const informeId = this.$route.params.id
      const adjuntoContentId = this.adjunto.contentTypeId
      const markAsReadPath = `informe/${informeId}/adjunto/${adjuntoContentId}/observaciones/read`

      if (this.adjunto.tieneNotificaciones) {
        this.axios
          .put(markAsReadPath)
          .then(() => {
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
          })
      }
    }
  },
  created () {
    this.marcarObservacionesLeidas()
  }
}
</script>

<style scoped>
  .attachment-card {
    padding: 2rem;
    background-color: #DDDDDD;
  }
  a {
    color: #1787c9;
  }
  .attach-button {
    font-size:0.9em;
    padding-left: 0.6em;
  }
  .row-element {
    background-color: #f0f0f2;
  }
  .custom-font-semi-bold {
    font-family: SourceSansProSemiBold, sans-serif;
  }
  .custom-text {
    margin: 0.5em 0 0.5em 0.2em;
    font-size: 1.1em;
  }
  .text-grey {
    color: #413d3d;
  }
  .documento-error {
    color: red;
  }
  .divisor {
    margin-left: 5px;
    margin-right: 5px;
  }
</style>
